import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';

@Component({
  selector: 'app-add-bank-detail',
  templateUrl: './add-bank-detail.component.html',
  styleUrls: ['./add-bank-detail.component.scss']
})
export class AddBankDetailComponent {
  public addForm!: FormGroup;
  public employeeId!: string;
  constructor(private fb: FormBuilder, private appService: AppService, private dialogRef: MatDialogRef<AddBankDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private commonService: CommonService, private spinner: NgxSpinnerService, private recruiterService: RecruiterService,
  ) { }

  ngOnInit(): void {
    this.addForm = this.fb.group({
      bank_id: [""],   
      ac_hn: ["", Validators.required],
      ac_n: ["", Validators.required],
      b_n: ["", Validators.required],
      ib_n: ["", Validators.required],
      pps_n: ["", Validators.required],
      s_c: ["", Validators.required],
      b_add: ["", Validators.required],
    })

    if (this.dialogData?.em_i) {
      this.employeeId = this.dialogData?.em_i
    }

    if (this.dialogData?.Type === 'edit' && this.dialogData?.bankDate) {
      const editData = {
        ...this.dialogData.bankDate,
        bank_id: this.dialogData.bankDate.id  // Map `id` to `bank_id`
      };
      this.addForm.patchValue(editData);
      this.employeeId = this.dialogData.bankDate.em_i || this.employeeId;
    }
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  onCancel() {
    this.dialogRef.close()
  }
  // onSubmit() {
  //   if (this.addForm.valid == false) {
  //     this.addForm.markAllAsTouched()
  //     return
  //   }
  //   let obj = this.addForm.value;
  //   obj["em_i"] = this.employeeId
  //   this.recruiterService.addBank(obj).subscribe({
  //     next: (success: any) => {
  //       //this.spinner.hide()
  //       this.appService.showToastMessage('success', success.msg);
  //       this.dialogRef.close({ data_added: true })
  //     },
  //     error: (error: any) => {
  //       this.commonService.handleError(error);
  //     },
  //   });
  // }

  onSubmit() {
    if (this.addForm.invalid) {
      this.addForm.markAllAsTouched();
      return;
    }

    const obj = { ...this.addForm.value, em_i: this.employeeId };

    if (this.dialogData?.Type === 'edit') {
      // Call update API
      this.recruiterService.editBank(obj).subscribe({
        next: (success: any) => {
          this.appService.showToastMessage('success', success.msg);
          this.dialogRef.close({ data_updated: true });
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    } else {
      // Call add API
      this.recruiterService.addBank(obj).subscribe({
        next: (success: any) => {
          this.appService.showToastMessage('success', success.msg);
          this.dialogRef.close({ data_added: true });
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
  }

}
